import { render, staticRenderFns } from "./TaoCanBo.vue?vue&type=template&id=09a95d21&"
import script from "./TaoCanBo.vue?vue&type=script&lang=js&"
export * from "./TaoCanBo.vue?vue&type=script&lang=js&"
import style0 from "./TaoCanBo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports